import { Dialog, DialogTitle, DialogContent, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import React from 'react';
import navbar_background from '../assets/navbar_background.svg';
import { Close, PlayArrow } from '@mui/icons-material';

// Definição do tipo de propriedades aceitas pelo componente TutorialsDialog.
// `open`: controla a visibilidade do diálogo. 
// `onClose`: função que é chamada quando o diálogo é fechado.
type Props = {
    open: boolean,
    onClose: (() => void)
}

// Array que contém os vídeos que serão exibidos na tabela.
// Cada item do array possui dois campos: `description` (título do vídeo) e `link` (URL do vídeo no YouTube).
// Para adicionar novos vídeos, basta inserir um novo objeto no formato { description: 'Título', link: 'URL do vídeo' }.
const videoData = [
    { description: 'Vídeo institucional do Quanto Custa', link: 'https://youtu.be/Hm8KHYi-2sc' },
];

function TutorialsDialog({ open, onClose }: Props) {
    return (
        // Componente Dialog do Material UI que encapsula o conteúdo do modal de tutoriais.
        // As props `open` e `onClose` controlam se o diálogo está visível e como ele é fechado.
        <Dialog
            open={open}
            keepMounted
            onClose={onClose}
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth='sm'
        >
            {/* Cabeçalho do diálogo */}
            <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                {/* Título do modal */}
                <Typography variant="h4">Tutoriais</Typography>

                {/* Botão para fechar o modal (ícone de X no canto superior direito) */}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 15,
                        top: 15,
                    }}
                >
                    <Close sx={{ color: "white" }} />
                </IconButton>
            </DialogTitle>

            {/* Conteúdo principal do modal (Tabela com os tutoriais) */}
            <DialogContent sx={{ textAlign: 'center', m: 1 }}>
                <TableContainer component={Paper}>
                    <Table aria-label="tutorials table">
                        {/* Cabeçalho da tabela, com as colunas "Descrição" e "Link" */}
                        <TableHead>
                            <TableRow>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Descrição</TableCell>
                                <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }} align="center">Vídeo</TableCell>
                            </TableRow>
                        </TableHead>
                        
                        {/* Corpo da tabela, onde cada vídeo é exibido em uma linha */}
                        <TableBody>
                            {videoData.map((row) => (
                                <TableRow key={row.description}>
                                    {/* Coluna de descrição do vídeo */}
                                    <TableCell component="th" scope="row" sx={{ fontSize: '1rem' }}>
                                        {row.description}
                                    </TableCell>

                                    {/* Coluna de link com o ícone "play", que redireciona para o link do vídeo */}
                                    <TableCell align="center" sx={{ fontSize: '1rem' }}>
                                        <IconButton
                                            aria-label="play"
                                            onClick={() => window.open(row.link, '_blank')} // Abre o link do vídeo em uma nova aba
                                            color='primary'
                                        >
                                            <PlayArrow />
                                        </IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </DialogContent>
        </Dialog>
    );
}

export default TutorialsDialog;
